import React from "react";
import {
  Typography,
  Grid,
  Button,
  Link,
  TextField,
  Paper,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as IconIdCard } from "../../icons/idCard.svg";
import colors from "../colors";
import imageToBase64 from "image-to-base64/browser";
import { useSelector, useDispatch } from "react-redux";
import {
  setIdExpiryDate,
  setIdNumber,
  setIdPictureBase64,
  setIdPictureExtension,
  decrementCurrentRegistrationStep,
  incrementCurrentRegistrationStep,
  selectRegistrationState,
  setShouldFourthStepBeSkipped,
  setUploadedImage,
} from "../../features/registration/registrationSlice";
import moment from "moment";
import { useFormik } from "formik";
import * as yup from "yup";
import { LocalizationProvider } from "@mui/lab";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { texts } from "../general/texts";
import { selectLoginState } from "../../features/login/loginSlice";
import { sendGeneralRequest } from "../../features/generalRequest";
import { useNavigate } from "react-router-dom";
import { selectGlobalDataState } from "../../features/global/globalDataSlice";
import FacephiFlow from "../registration/facephi/FacephiFlow";
import { ReactComponent as IconEasyPayLogo } from '../../icons/epIconNew.svg';
import { ReactComponent as IconClose } from '../../icons/closeButton.svg';
//import { setIsSelphIDCompleted, setIsSelphiCompleted } from "../../features/utilities/utilitySlice";
const validationSchema = yup.object({
  idExpiryDate: yup
    .string(texts["message-invalid-expiry-date"])
    //   .matches(/^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/,{
    //     message:'Data duhet te jete ne formatin DD/MM/YYYY'
    //     })
    .required(texts["message-invalid-expiry-date"])
    .nullable(),
  idBase64: yup.string().required(),
  extension: yup.string().required(),
});

const UpdateIdCard = (props) => {
  const dispatch = useDispatch();
  const loginSliceState = useSelector(selectLoginState);
  const globalDataSliceState = useSelector(selectGlobalDataState)
  const registrationSliceState = useSelector(selectRegistrationState);
  const navigate = useNavigate()
  const removePrefix = (base64String) => {
    if (base64String.startsWith('data:image/jpeg;base64,')) {
      return base64String.slice('data:image/jpeg;base64,'.length);
    }
    return base64String;
  };

  const modifiedBase64 = removePrefix(registrationSliceState.idPictureBase64);

//   const setOnSelphiComplete = (event) => {
//     debugger
//     setIsSelphiCompleted(event)
// };

// const setOnSelphIdComplete = (event) => {
//     debugger
//     setIsSelphIDCompleted(event)
// };

  const updateCardFromFacephi = () => {
    dispatch(
      sendGeneralRequest({
        request: {
          _request: {
            token: loginSliceState.token,
            ext: registrationSliceState.idPictureExtension,
            base64Content: modifiedBase64,
            expiryDate: registrationSliceState.idExpiryDate,
          },
        },
        baseUrlKey: "auth",
        endpoint: "UpdateIDCard",
      })
    );
    navigate('/login')
  }

  if (registrationSliceState.idExpiryDate !== "" && registrationSliceState.base64Content !== "" && registrationSliceState.idPictureExtension !== "") {
    updateCardFromFacephi();
  }

  const formik = useFormik({
    initialValues: {
      idBase64: modifiedBase64,
      idExpiryDate: registrationSliceState.idExpiryDate,
      extension: registrationSliceState.idPictureExtension
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(
        sendGeneralRequest({
          request: {
            _request: {
              token: loginSliceState.token,
              ext: values.extension,
              base64Content: values.idBase64,
              expiryDate: moment(values.idExpiryDate).format('DD/MM/yyyy'),
            },
          },
          baseUrlKey: "auth",
          endpoint: "UpdateIDCard",
        })
      );
    },
  });
  /////////////////DatePicker//////////////////////////

  const [value, setValue] = React.useState(new Date());

  /////////////////////////////////////////////////////

  const uploadImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      dispatch(setUploadedImage(URL.createObjectURL(e.target.files[0])));
    }
  };

  const removeUploadedImage = () => {
    dispatch(setUploadedImage(""));
    setUploadedImage("");
    formik.setFieldValue("extension", "");
    formik.setFieldValue("idBase64", "");
  };

  const handleInputChange = (e) => {
    uploadImage(e);
    imageToBase64(URL.createObjectURL(e.target.files[0]))
      .then((response) => {
        formik.setFieldValue("extension", e.target.files[0].type.split("/")[1]);
        formik.setFieldValue("idBase64", response);
      })
      .catch((error) => { });
  };

  const onBackButtonClick = () => {
    navigate('/login')
  }

  React.useEffect(() => {
    globalDataSliceState.isLoggedIn && navigate('/dashboard')
    loginSliceState.token === '' && navigate('/login')
  }, [])

  // React.useEffect(()=>{
  //     formik.setFieldValue('idBase64', registrationSliceState.idPictureBase64)
  //     formik.setFieldValue('idExpiryDate', registrationSliceState.idExpiryDate)
  //     formik.setFieldValue('extension', registrationSliceState.idPictureExtension)
  // },[registrationSliceState.idExpiryDate, registrationSliceState.idPictureBase64, registrationSliceState.idPictureExtension])

  return (
    <>
      {!loginSliceState.isManualRegistration ? (
        <Grid container justifyContent="center" alignItems="center" marginTop={10} pb={{ sm: 10, xs: 10 }}>
          <Grid container item md={12} xs={12} flexDirection={'row'} justifyContent={'space-between'}>
            <Grid item md={6} mt={3} display={{ xs: 'none', md: 'block' }} >
              <IconEasyPayLogo width={'20%'} />
            </Grid>
            <Grid container item md={6} xs={10} marginBottom={9} paddingTop={3} justifyContent={'center'} sx={{ '@media (max-width: 899px)': { justifyContent: 'right' } }} >
              <Button sx={{ borderRadius: '20px', ":hover": { backgroundColor: colors.lightOrange } }} onClick={() => navigate('/login')}><IconClose /></Button>
            </Grid>
          </Grid>
          <Typography sx={{ color: colors.darkBlue, fontFamily: 'GerberaBold', fontSize: '2rem', mt: 10, mb: 15 }}>
            Ndiqni hapat per ngarkimin e kartes se id.
          </Typography>
          <FacephiFlow 
          //onSelphiComplete={setOnSelphiComplete} onSelphIdComplete={setOnSelphIdComplete}
          />
        </Grid>
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <Grid container flexDirection="column" justifyContent="center" alignItems="space-between">
            <Grid container item md={12} xs={12} flexDirection={'column'} alignContent={'center'} marginTop={30}>
              <Grid container item md={2.5} xs={11} justifyContent="flex-start" alignItems="flex-start">
                <Typography sx={{ fontFamily: 'GerberaMedium', color: colors.orange, fontSize: '1.1rem' }}>
                  {registrationSliceState.accountType === "2" ? (
                    texts["title-registration-expiryDate-business"]
                  ) : (

                    texts["title-registration-expiryDate"]
                  )}
                </Typography>
              </Grid>
              <Grid container item md={2} xs={8} justifyContent="flex-start" alignItems="flex-start">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Stack spacing={3}>
                    <DesktopDatePicker
                      inputFormat="dd/MM/yyyy"
                      openTo="day"
                      views={["day", "month", "year"]}
                      value={formik.values.idExpiryDate}
                      onChange={(val) => {
                        formik.setFieldValue("idExpiryDate", val);
                      }}
                      color={"warning"}
                      renderInput={(params) => (
                        <TextField
                          variant="standard"
                          id="idExpiryDate"
                          name="idExpiryDate"
                          placeholder="dd/mm/yyyy"
                          color={"warning"}
                          helperText={
                            formik.touched.idExpiryDate &&
                            formik.errors.idExpiryDate
                          }
                          {...params}
                          error={
                            formik.touched.idExpiryDate &&
                            Boolean(formik.errors.idExpiryDate)
                          }
                        />
                      )}
                    />
                  </Stack>
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Grid container item md={12} xs={12} justifyContent={'center'} marginTop={10}>
              <Paper elevation={1} sx={{ paddingTop: '5%', paddingBottom: '5%', width: '50%', borderRadius: '20px', boxShadow: '0 0 15px 5px #E5E7EA', '@media (max-width: 899px )': { width: '80%' } }} >
                {registrationSliceState.uploadedImage === "" ? (
                  <Grid container>
                    <Grid item md={6} sm={12} xs={12}>
                      <IconIdCard />
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} pt={"3%"}>
                      <Typography
                        variant="standard"
                        sx={{ color: colors.darkBlue, fontSize: '0.5 rem', fontFamily: 'GerberaLight' }}
                      >
                        {texts["prompt-upload-id"]}
                      </Typography>
                      <Grid item marginTop={3}>
                        <Grid>
                          <input
                            accept="image/*"
                            id="upload-company-logo"
                            onChange={handleInputChange}
                            type="file"
                            hidden
                          />
                          <label htmlFor="upload-company-logo">
                            <Button
                              component="span"
                              sx={{ color: colors.orange, fontFamily: 'GerberaBold', "&:hover": { backgroundColor: 'white', color: '#FF8403' } }}
                            >
                              {texts["button-upload"]}
                            </Button>
                          </label>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container item md={12} xs={12} justifyContent={"center"}>
                    <Grid
                      container
                      item
                      md={6}
                      xs={12}
                      pb={"3%"}
                      justifyContent={"center"}
                    >
                      <img
                        style={{
                          width: "300px",
                          height: "150px",
                          borderRadius: "20px",
                        }}
                        src={registrationSliceState.uploadedImage}
                        alt="Thumb"
                      />
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <Link
                        component="button"
                        onClick={removeUploadedImage}
                        sx={{ color: colors.orange, fontFamily: 'GerberaLight', textDecorationColor: colors.orange, "&:hover": { textDecorationColor: '#FF8403', color: '#FF8403' } }}
                      >
                        {texts["button-delete"]}
                      </Link>
                    </Grid>
                  </Grid>
                )}
              </Paper>
            </Grid>
            <Grid item md={12} xs={12} pt={'2%'}>
              <Button disabled={registrationSliceState.isLoading ? true : false} type='submit' sx={{
                background: colors.gradientOrange,
                color: colors.white,
                width: '12%',
                fontFamily: 'GerberaBold',
                fontSize: '1rem',
                textTransform: 'none',
                '@media (max-width: 899px)': { width: '40%' }
              }}>{texts["button-continue"]}</Button>
            </Grid>
          </Grid>
          <Grid item md={12} xs={12} pt={2}>
            <Link disabled={registrationSliceState.isLoading ? true : false} sx={{
              color: colors.orange,
              fontFamily: 'GerberaLight',
              textDecorationColor: colors.orange,
              "&:hover": { textDecorationColor: '#FF8403', color: '#FF8403' }
            }}
              onClick={onBackButtonClick} component='button' variant='body2'>{texts["button-back"]}</Link>
          </Grid>
        </form>
      )}
    </>
  );
};

export default UpdateIdCard;